import React, { useRef } from "react";
import Box from "@mui/material/Box";
import { CSSTransition } from "react-transition-group";
import PropTypes from "prop-types";
import classNames from "classnames";

const TextBubble = ({ loaded, text }) => {
    const nodeRef = useRef(null);

    return (
        <CSSTransition nodeRef={nodeRef} in={loaded} timeout={500}>
            {(state) => <Box className={classNames("ws-text-bubble", state)}>{text}</Box>}
        </CSSTransition>
    );
};

TextBubble.propTypes = {
    loaded: PropTypes.bool,
    text: PropTypes.node,
};

TextBubble.defaultProps = {
    loaded: false,
    text: "",
};

export default React.memo(TextBubble);
